import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M26.845 6.255a1 1 0 0 0-1.414-1.414l-5.293 5.293V7.548a1 1 0 1 0-2 0v5.003a1 1 0 0 0 .291.702l.004.005c.194.193.448.29.702.29h5.003a1 1 0 1 0 0-2h-2.586zM7.138 18.548a1 1 0 0 1 1-1h5.003c.274.001.522.112.702.291l.004.004a1 1 0 0 1 .291.702v5.003a1 1 0 1 1-2 0v-2.585l-5.293 5.292a1 1 0 1 1-1.414-1.414l5.293-5.293H8.138a1 1 0 0 1-1-1M18.755 17.624a1 1 0 0 1 .38-.076h5.003a1 1 0 0 1 0 2h-2.586l5.293 5.293a1 1 0 0 1-1.414 1.414l-5.293-5.292v2.585a1 1 0 1 1-2 0v-5.002999999999999c.001-.271.11-.517.287-.697l.013-.013a1 1 0 0 1 .317-.21M12.138 7.548a1 1 0 1 1 2 0v5.003a.997.997 0 0 1-.997.997H8.138a1 1 0 1 1 0-2h2.586L5.431 6.255a1 1 0 1 1 1.414-1.414l5.293 5.293z"
    />
  </svg>
);
const SvgIconArrowsIn = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconArrowsIn);
export default Memo;
